import { useEffect, useRef } from 'react'

import { ConfirmationModalButtons } from '../../../Confirmation'

function AppointmentFollowUpModalButtons({ cancelProps, ...restProps }) {
  const cancelRef = useRef(null)

  // CAL-02 §7.5: the focus starts on the branch that writes nothing; set here, once the portal has the buttons
  useEffect(() => {
    cancelRef.current?.focus()
  }, [])

  return (
    <ConfirmationModalButtons
      {...restProps}
      cancelProps={{ ...cancelProps, elementRef: cancelRef }}
    />
  )
}

export default AppointmentFollowUpModalButtons
